import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { Component, Input, OnChanges, Output, SimpleChanges } from 'angular-ts-decorators';
import { CustomizerFilter, FilterOption, ICustomizerApiFilter, OnSelectionChangeHandler } from '../../../models';
import { filterGroupsByFilters, getApplicableFilters, isColorFilter, processFilters, setOptionsChecked } from '../../../utils';

import template from './hero-customizer-v3-filters.component.html';

@Component({
  selector: 'heroCustomizerV3Filters',
  template,
})
export class HeroCustomizerV3FiltersComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public apiFilters?: ICustomizerApiFilter[];
  @Input() public group?: IProductWithAttributes;
  @Input() public groups?: IProductWithAttributes[];

  @Output() public onSelectionChange?: OnSelectionChangeHandler;

  public filters?: CustomizerFilter[];
  public availableFilters?: CustomizerFilter[];

  public ngOnChanges(changes: SimpleChanges<HeroCustomizerV3FiltersComponent>) {
    if (changes.groups && this.groups) {
      this.filters = getApplicableFilters(this.groups, this.apiFilters.map((x: ICustomizerApiFilter) => new CustomizerFilter(x)));
      this.availableFilters = this.filters.filter((f: CustomizerFilter) => this.isRadio(f) || this.isCheckbox(f) || this.isColor(f));
      if (changes.groups.isFirstChange) {
        setOptionsChecked(this.group, this.filters);
        processFilters(this.groups, this.filters);
      }
    }
  }

  public isRadio(filter: CustomizerFilter): boolean {
    return !this.isCheckbox(filter) && !this.isColor(filter) && filter.options.filter((x: FilterOption) => x.visible).length > 1;
  }

  public isCheckbox(filter: CustomizerFilter): boolean {
    return filter.options.length === 1 && filter.options.filter((x: FilterOption) => x.visible).length === 1;
  }

  public isColor(filter: CustomizerFilter): boolean {
    return isColorFilter(filter);
  }

  public onFilterChange() {
    const filteredGroups = filterGroupsByFilters(this.groups, this.filters);
    processFilters(this.groups, this.filters);
    if (this.onSelectionChange) {
      this.onSelectionChange({ group: filteredGroups[0] });
    }
  }

  public get hasAvailableFilters(): boolean {
    return this.availableFilters && this.availableFilters.length > 0;
  }
}
